var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayeredContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a4d448bf-d2c0-43c6-acc8-87eb536ce2d1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .ab88942e-e930-44c2-9247-cd23f8e07a3b {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "ab88942e-e930-44c2-9247-cd23f8e07a3b",
    points: "63.51 39.879 67.892 41.66 50 48.931 32.108 41.66 36.49 39.879 33.039 38.477 25.205 41.66 50 51.736 74.795 41.66 66.961 38.477 63.51 39.879"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab88942e-e930-44c2-9247-cd23f8e07a3b",
    d: "M74.8,18.34,50,8.264,25.205,18.34,50,28.416ZM50,11.069,67.892,18.34,50,25.611,32.108,18.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ab88942e-e930-44c2-9247-cd23f8e07a3b",
    points: "63.848 24.473 67.892 26.116 50 33.388 32.108 26.116 36.152 24.473 32.701 23.07 25.205 26.116 50 36.192 74.795 26.116 67.299 23.07 63.848 24.473"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ab88942e-e930-44c2-9247-cd23f8e07a3b",
    points: "64.197 32.108 67.892 33.609 50 40.88 32.108 33.609 35.803 32.108 32.352 30.705 25.205 33.609 50 43.685 74.795 33.609 67.648 30.705 64.197 32.108"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredContent);
export default __webpack_public_path__ + "static/media/LayeredContent.d5481602fac63cebe5e7eb086b3c1dc5.svg";
export { ForwardRef as ReactComponent };